import {configureStore} from '@reduxjs/toolkit'
import user_state from '../state/user_state'
import cost_estimator from '../state/cost_estimator'

export default configureStore({
    reducer: {
        user_state: user_state,
        cost_estimator: cost_estimator,
    }
})
